import { MemoType } from 'models/Memo';
import React, { createContext, useContext } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { FormMode } from '../MemoForm';

interface MemoFormContext extends UseFormReturn<any> {
  // Whether the form is in Creation Mode or Edition Mode
  mode: FormMode;
  // Whether the form is being submitted
  isSubmitting: boolean;
  // The type of memo currently selected
  selectedMemoType: MemoType;
  // Title
  isTitleVisible: boolean;
  toggleTitle: () => void;
  canShowTitle: boolean;
  //Description
  isDescriptionVisible: boolean;
  toggleDescription: () => void;
  canShowDescription: boolean;
  //Source
  isSourceVisible: boolean;
  toggleSource: () => void;
  canShowSource: boolean;
  isFullyExpanded?: boolean;
}

const FormContext = createContext<MemoFormContext | null>(null);

/**
 * Extends the `react-hook-form` context with MemoForm-specific state and logic
 * (e.g., title visibility management).
 */
export const useMemoFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error(
      'useMemoFormContext must be used within a FormContextProvider',
    );
  }
  return context;
};

export const FormContextProvider: React.FC<{
  value: MemoFormContext;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <FormContext.Provider value={value}>
    <FormProvider {...value}>{children}</FormProvider>
  </FormContext.Provider>
);
